export type CompliancePolicy = 'sharia' | 'standard';

export const VALID_COMPLIANCE_POLICIES: CompliancePolicy[] = [
  'sharia',
  'standard',
];

export function isValidCompliancePolicy(
  value: string | null | undefined,
): value is CompliancePolicy {
  return VALID_COMPLIANCE_POLICIES.includes(value as CompliancePolicy);
}
